import React from "react";
import { Button, Modal } from "@mui/material";
import styles from "./PublishModal.module.scss";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  name: string;
  isPublished: boolean;
  onHandle: () => void;
};

const PublishModal = ({
  isOpen,
  setIsOpen,
  name,
  isPublished,
  onHandle,
}: Props) => {
  return (
    <Modal
      aria-labelledby="modal-delete"
      aria-describedby="Removal from the system. Confirm the deletion"
      open={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <div className={styles.modalContainer}>
        <h3 className={styles.modalTitle}>
          {isPublished ? "Hide" : "Show"}{" "}
          <span className={styles.modalTitleBlue}>{name}?</span>
        </h3>
        <div className={styles.modalContent}>
          <div className={styles.btns}>
            <Button
              sx={{
                textTransform: "capitalize",
                height: "44px",
                width: "130px",
                backgroundColor: "#5570f1",
                border: "none",
                borderRadius: "12px",
                "&:hover": {
                  backgroundColor: "#5570f1",
                },
              }}
              variant="contained"
              onClick={onHandle}
            >
              {isPublished ? "Hide" : "Show"}
            </Button>

            <Button
              variant="outlined"
              sx={{
                textTransform: "capitalize",
                height: "44px",
                width: "130px",
                border: "1px solid #5570F1",
                color: "#5570F1",
                borderRadius: "12px",
              }}
              onClick={() => setIsOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PublishModal;
